/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsPerformanceCustomFieldCleanupRoute } from '@jira/router-routes__admin-pages-performance-routes/src/globalSettingsPerformanceCustomFieldCleanupRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { customFieldCleanupMetricDetailEntryPoint } from './ui/spa/admin-pages/performance/metric-detail/custom-field/cleanup/index.tsx';

export const globalSettingsPerformanceCustomFieldCleanupRouteEntry: Route = createEntry(
	globalSettingsPerformanceCustomFieldCleanupRoute,
	() => ({
		group: 'global-settings',

		entryPoint() {
			return customFieldCleanupMetricDetailEntryPoint;
		},

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],
		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
